import React, { useState } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";
import { createPolicyApi, createUser } from "../../services";

export const NewPolicyModal = ({ showUser, toggleShowUser, refetch }) => {
  const [register, setRegister] = useState({});
  const [isRegistering, setIsRegistering] = useState(false);
  const [step, setStep] = useState(1);
  const [fillFields, setFillFields] = useState(false);
  const navigate = useNavigate();

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => ({ ...prev, [name]: value }));
  };

  const validateCurrentStep = () => {
    const requiredStep1 = [
      "policyNumber",
      "noOfEmployees",
      "insured",
      "policyDescription",
      "mobileNumber",
      // "occupation",
      "postalCode",
      "officeAddress",
    ];

    const requiredStep2 = [
      "commencementDate",
      "expiryDate",
      "employerType",
      "employerCity",
      "employerState",
      // "postalCode",
      "employerRcNumber",
      "employerOccupation",
    ];

    const requiredStep3 = [
      "employerEmail",
      "employerNature",
      "insuranceBenefit",
      "sumAssured",
      "premium",
      "commissionFee",
      "extraFee",
    ];

    const requiredFields =
      step === 1 ? requiredStep1 : step === 2 ? requiredStep2 : requiredStep3;

    for (let field of requiredFields) {
      if (!register[field]?.toString().trim()) {
        return false;
      }
    }
    return true;
  };

  const CreateUserCall = async (values) => {
    setIsRegistering(true);
    values.noOfEmployees = Number(values.noOfEmployees)
    values.sumAssured = Number(values.sumAssured)
    values.premium = Number(values.premium)
    values.commissionFee = Number(values.commissionFee)
    values.extraFee = Number(values.extraFee)

    delete values.emailAddress

    await createPolicyApi(values)
      .then((res) => {
        notify("success", "Policy created.", res?.message);
        setRegister({});
        setStep(1);
        setIsRegistering(false);
        toggleShowUser();
        refetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsRegistering(false);
      });
  };

  return (
    <Modal show={showUser} onHide={toggleShowUser} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>New policy</Modal.Title>
          <div className="surface-card__meta">
            Add a policy that can be pushed to NIID and NAICOM
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="stepper">
          {["Policy", "Employer", "Product"].map((label, index) => {
            const position = index + 1;
            return (
              <React.Fragment key={label}>
                <div
                  className={`stepper__step ${
                    position === step
                      ? "stepper__step--active"
                      : position < step
                      ? "stepper__step--done"
                      : ""
                  }`}
                >
                  {position < step ? "✓" : position}
                </div>
                {index < 2 && (
                  <div
                    className={`stepper__line ${
                      position < step ? "stepper__line--done" : ""
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="stepper__labels">
          {["Policy", "Employer", "Product"].map((label, index) => (
            <div
              key={label}
              className={`stepper__label ${
                index + 1 === step ? "stepper__label--active" : ""
              }`}
            >
              {label}
            </div>
          ))}
        </div>

        <Form className="d-flex flex-column gap-3">
          {step === 1 ? (
            <div style={{ marginTop: "20px" }}>
              <Row>
                <Form.Group as={Col}>
                  <Form.Label>Policy number</Form.Label>
                  <Form.Control name="policyNumber" value={register?.policyNumber || ""} onChange={handleRegisterChange} required />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>No of Employees</Form.Label>
                  <Form.Control type="number" name="noOfEmployees" value={register?.noOfEmployees || ""} onChange={handleRegisterChange} required />
                </Form.Group>
              </Row>
              <Form.Group>
                <Form.Label>Insured</Form.Label>
                <Form.Control name="insured" onChange={handleRegisterChange} value={register?.insured || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Policy Description</Form.Label>
                <Form.Control name="policyDescription" onChange={handleRegisterChange} value={register?.policyDescription || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Phone number</Form.Label>
                <Form.Control name="mobileNumber" onChange={handleRegisterChange} value={register?.mobileNumber || ""} required />
              </Form.Group>
              {/* <Form.Group>
                <Form.Label>Occupation</Form.Label>
                <Form.Control name="occupation" onChange={handleRegisterChange} value={register?.occupation || ""} required />
              </Form.Group> */}
              <Form.Group>
                <Form.Label>Postal code</Form.Label>
                <Form.Control name="postalCode" onChange={handleRegisterChange} value={register?.postalCode || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Office Address</Form.Label>
                <Form.Control name="officeAddress" onChange={handleRegisterChange} value={register?.officeAddress || ""} required />
              </Form.Group>
            </div>
          ) : step === 2 ? (
            <div style={{ marginTop: "20px" }}>
              <Row>
                <Form.Group as={Col}>
                  <Form.Label>Commencement date</Form.Label>
                  <Form.Control type="date" name="commencementDate" value={register?.commencementDate || ""} onChange={handleRegisterChange} required />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Expiry date</Form.Label>
                  <Form.Control type="date" name="expiryDate" value={register?.expiryDate || ""} onChange={handleRegisterChange} required />
                </Form.Group>
              </Row>
              <Form.Group>
                <Form.Label>Employer type</Form.Label>
                <Form.Control name="employerType" onChange={handleRegisterChange} value={register?.employerType || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Employer city</Form.Label>
                <Form.Control name="employerCity" onChange={handleRegisterChange} value={register?.employerCity || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Employer state</Form.Label>
                <Form.Control name="employerState" onChange={handleRegisterChange} value={register?.employerState || ""} required />
              </Form.Group>
              
              <Form.Group>
                <Form.Label>Employer RC number</Form.Label>
                <Form.Control name="employerRcNumber" onChange={handleRegisterChange} value={register?.employerRcNumber || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Employer occupation</Form.Label>
                <Form.Control name="employerOccupation" onChange={handleRegisterChange} value={register?.employerOccupation || ""} required />
              </Form.Group>
            </div>
          ) : (
            <div style={{ marginTop: "20px" }}>
              <Form.Group>
                <Form.Label>Employer email</Form.Label>
                <Form.Control name="employerEmail" onChange={handleRegisterChange} value={register?.employerEmail || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Employer nature</Form.Label>
                <Form.Control name="employerNature" onChange={handleRegisterChange} value={register?.employerNature || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Insurance benefit</Form.Label>
                <Form.Control name="insuranceBenefit" onChange={handleRegisterChange} value={register?.insuranceBenefit || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Sum assured</Form.Label>
                <Form.Control name="sumAssured" type="number" onChange={handleRegisterChange} value={register?.sumAssured || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Premium</Form.Label>
                <Form.Control name="premium" type="number" onChange={handleRegisterChange} value={register?.premium || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Commission fee</Form.Label>
                <Form.Control name="commissionFee" type="number" onChange={handleRegisterChange} value={register?.commissionFee || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Extra fee</Form.Label>
                <Form.Control name="extraFee" type="number" onChange={handleRegisterChange} value={register?.extraFee || ""} required />
              </Form.Group>
            </div>
          )}

          {fillFields && (
            <p style={{ color: "red", fontWeight: "600" }}>Please fill all fields</p>
          )}

        </Form>
      </Modal.Body>

      <Modal.Footer>
        {step > 1 && (
          <Button
            variant="outline-secondary"
            onClick={(e) => {
              e.preventDefault();
              setStep(step - 1);
            }}
            disabled={isRegistering}
          >
            Back
          </Button>
        )}
        <Button
          variant="primary"
          onClick={async (e) => {
            e.preventDefault();
            if (!validateCurrentStep()) {
              setFillFields(true);
              return;
            } else {
              setFillFields(false);
            }

            if (step < 3) {
              setStep(step + 1);
            } else {
              await CreateUserCall(register);
            }
          }}
          disabled={isRegistering}
        >
          {isRegistering ? "Creating..." : step === 3 ? "Create policy" : "Next"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
